import { defineStore } from 'pinia'

interface ModalInterface {
  login: boolean
  register: boolean
  forgotPassword: boolean
  cart: boolean
  addressNew: boolean
  shippingSelect: boolean
  addressEdit: boolean
  sizeChart: boolean
  recalculate: boolean
  additionalInfoSuccess: boolean
}

// @TODO: Rename store name, since it covers more than cart now.
export const useCartModalStore = defineStore('cartModal', {
  state: (): ModalInterface => ({
    login: false,
    register: false,
    forgotPassword: false,
    cart: false,
    addressNew: false,
    addressEdit: false,
    sizeChart: false,
    recalculate: false,
    additionalInfoSuccess: false,
    shippingSelect: false,
  }),
  getters: {
    isLoginVisible(state) {
      return state.login
    },
    isRegisterVisible(state) {
      return state.register
    },
    isForgotPasswordVisible(state) {
      return state.forgotPassword
    },
    isCartVisible(state) {
      return state.cart
    },
    isAddressNewVisible(state) {
      return state.addressNew
    },
    isAddressEditVisible(state) {
      return state.addressEdit
    },
    isSizeChartVisible(state) {
      return state.sizeChart
    },
    isRecalculateVisible(state) {
      return state.recalculate
    },
    isAdditionalInfoSuccessVisible(state) {
      return state.additionalInfoSuccess
    },
    isShippingSelectVisible(state) {
      return state.shippingSelect
    },
  },
  actions: {
    close() {
      this.login = false
      this.register = false
      this.forgotPassword = false
      this.cart = false
      this.addressNew = false
      this.addressEdit = false
      this.sizeChart = false
      this.recalculate = false
      this.additionalInfoSuccess = false
      this.shippingSelect = false
    },
    // Toggles
    toggleLogin() {
      this.login = !this.login
    },
    toggleRegister() {
      this.register = !this.register
    },
    toggleForgotPassword() {
      this.forgotPassword = !this.forgotPassword
    },
    toggleCart() {
      this.cart = !this.cart
    },
    toggleAddressNew() {
      this.addressNew = !this.addressNew
    },
    toggleAddressEdit() {
      this.addressEdit = !this.addressEdit
    },
    toggleSizeChart() {
      this.sizeChart = !this.sizeChart
    },
    toggleRecalculate() {
      this.recalculate = !this.recalculate
    },
    toggleAdditionalInfoSuccess() {
      this.additionalInfoSuccess = !this.additionalInfoSuccess
    },
    // Setters
    setVisibleShippingSelect(value: boolean) {
      this.shippingSelect = value
    },
    setVisibleLogin(value: boolean) {
      this.login = value
    },
    setVisibleRegister(value: boolean) {
      this.register = value
    },
    setVisibleForgotPassword(value: boolean) {
      this.forgotPassword = value
    },
    setVisibleCart(value: boolean) {
      this.cart = value
    },
    setVisibleAddressNew(value: boolean) {
      this.addressNew = value
    },
    setVisibleAddressEdit(value: boolean) {
      this.addressEdit = value
    },
    setVisibleSizeChart(value: boolean) {
      this.sizeChart = value
    },
    setRecalculate(value: boolean) {
      this.recalculate = value
    },
    setVisibleAdditionalInfoSuccess(value: boolean) {
      this.additionalInfoSuccess = value
    },
  },
})
